export interface TemplateConfig {
  id?: string;
  site_id?: string;

  config?: Config;
  theme?: Theme;
}
export interface Theme {
  id: string;
  label: string;
  path: string;

}

export interface Config {
  header: Header;
  footer: Footer;
  about_us: AboutUs;
  privacy_policy: PrivacyPolicy;
  contact_us: ContactUs;
  terms_conditions: TermsCondition;
  home_page: Home;
  pdp: PDP
  plp: PLP
}

export interface PDP {
  sections: Section[]; // Array of reusable sections
  visible: boolean;
}
export interface PLP {
  sections: Section[]; // Array of reusable sections
  visible: boolean;
}

export interface Home {
  sections: Section[]; // Array of reusable sections
  visible: boolean;
}

export interface AboutUs {
  sections: Section[]; // Array of reusable sections
  visible: boolean;
}

export interface ContactUs {
  sections: Section[]; // Array of reusable sections
  visible: boolean;
}

export interface PrivacyPolicy {
  sections: Section[]; // Array of reusable sections
  visible: boolean;
}

export interface TermsCondition {
  sections: Section[]; // Array of reusable sections
  visible: boolean;
}

export interface Footer {
  sections: Section[]; // Array of reusable sections
  visible: boolean;
}

export interface Header {
  sections: Section[]; // Array of reusable sections
  visible: boolean;
}

export interface Property {
  type: PropertyType; // e.g., "IMAGE", "TITLE", etc.
  visible: boolean;
  value?: string; // For properties like "value" in "logo" or "search"
  alt?: string; // Optional, for images
  title?: string; // Optional, for titles
  options?: PropertyOneOfOptions;
  menu_id?: string; // Menu identifier
  navigations?: Navigation[];
  display_title?: boolean;
  values?: Property[];
  fa?: string;
  action?: Navigation;
  endpoint: string;
}

export interface Navigation {
  label: string;
  slug?: string; // Optional for internal paths
  target: TargetType; // e.g., "INTERNAL_PAGE", "PLP"
  path?: string; // Optional for paths like "home", "contact-us"
  filter?: Filter;
}

export interface Filter {
  data: string[]; // Array of category IDs
  endpoint: string; // API endpoint for the filter
  by: string; // "CATEGORY_IDS"
}

export enum SocialShare {
  FACEBOOK = 'FACEBOOK',
  PINTEREST = 'PINTEREST',
  INSTAGRAM = 'INSTAGRAM',
  TWITTER = 'TWITTER',
  TIKTOK = 'TIKTOK',
  SNAPCHAT = 'SNAPCHAT',
  WHATSAPP = 'WHATSAPP',
}

export enum TargetType {
  PLP = 'PLP',
  PDP = 'PDP',
  INTERNAL_PAGE = 'INTERNAL_PAGE',
  EXTERNAL_PAGE = 'EXTERNAL_PAGE',
  PROMOS = 'PROMOS',
}

export interface MenuConfig {
  type: string; // "MENU"
  visible: boolean;
  visibility_editable: boolean;
  title: string;
  display_title: boolean;
  menu_id: string; // Menu identifier
  navigations: Navigation[];
}

export interface SectionConfig {
  // Generalized config structure for sections
  [key: string]: Property | Filter | ProductCard; // Allows flexibility for dynamic keys like "menu" or "search"
}

export interface PropertyOneOfOptions {
  // Generalized config structure for sections
  [key: string]: Property; // Allows flexibility for dynamic keys like "menu" or "search"
}

export interface SectionBase {
  section_id: string;
  label: string;
  type: SectionType; // e.g., "CUSTOM"
  visible: boolean;
  config: SectionConfig; // Dynamic section configuration
  sub_sections?: SectionBase[];
}

export interface SectionProducts extends SectionBase {
  config: {
    title: Property;
    shor_description: Property;
    description: Property;
    filter: Filter;
    product_card: ProductCard;
  };
}

export interface SectionProduct extends SectionBase {
  config: {
    title: Property;
    buy_now: Property;
    origin_price: Property;
    addToCart: Property;
    paymentOptions: Property;
    paymentOptionsTitle: Property;
    description: Property;
    stars: Property;
    share: Property;
    favorite: Property;
  };
}

export interface SectionCategories extends SectionBase {
  config: {
    title: Property;
    filter: Filter;
  };
}

export interface ProductCard {
  rating: boolean;
  origin_price: boolean;
  promo: boolean;
  badge: boolean;
}

export enum SectionType {
  CUSTOM = 'CUSTOM',
  PRODUCTS = 'PRODUCTS',
  MULTIPLE = 'MULTIPLE',
  NEWSLETTER = 'NEWSLETTER',
}

export enum PropertyType {
  TITLE = 'TITLE',
  DESCRIPTION = 'DESCRIPTION',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  BUTTON = 'BUTTON',
  IMAGE_BUTTON = 'IMAGE_BUTTON',
  BOOL = 'BOOL',
  FONT_ICON = 'FONT_ICON',
  LINKBLANK = 'LINKBLANK',
  HTML = 'HTML',
  LINK = 'LINK',
  LIST = 'LIST',
  MENU = 'MENU',
  INPUT = 'INPUT',
  SHARE = 'SHARE',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  ONEOF = 'ONEOF',
}

export type Section =
  | SectionBase
  | SectionProducts
  | SectionProduct
  | SectionCategories;
